import React from 'react';
import PropTypes from 'prop-types';

import CssBaseline from '@material-ui/core/CssBaseline';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import DateRangeIcon from '@material-ui/icons/DateRange';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import EventIcon from '@material-ui/icons/Event';
import DoneIcon from '@material-ui/icons/Done';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import BuildIcon from '@material-ui/icons/Build';
import ClearIcon from '@material-ui/icons/Clear';
import Tooltip from '@material-ui/core/Tooltip';
import Checkbox from '@material-ui/core/Checkbox';
import DateRangeDialog from '../utils/DateRangeDialog'
import moment from 'moment';
import 'moment/locale/fr';

import { Map as LMap, Marker, LayersControl, TileLayer, Popup, ZoomControl } from 'react-leaflet'
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import MarkerClusterGroup from 'react-leaflet-markercluster';
import markerAppointment from '../../assets/images/marker-appointment.png'
import markerAppointmentNotified from '../../assets/images/marker-appointment_notified.png'
import markerIssue from '../../assets/images/marker-issue.png'
import markerWaiting from '../../assets/images/marker-waiting.png'
import 'react-leaflet-markercluster/dist/styles.min.css';
import TextField from "@material-ui/core/TextField/TextField";
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from "@material-ui/core/Grid/Grid";
const { BaseLayer } = LayersControl

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

moment.locale('fr');
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

const styles = theme => ({
  map: {
    width: "100%",
    height: "100%",
    overflow: 'hidden',
  },
  searchField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    position: 'absolute',
    bottom: theme.spacing.unit * 3,
    right: theme.spacing.unit * 8,
    zIndex: 999
  },
  fab: {
    position: 'absolute',
    paddingLeft: 5,
    bottom: theme.spacing.unit * 14,
    right: theme.spacing.unit,
    zIndex: 999
  },
  extendedIcon: {
    marginRight: 5,
  },
  legend: {
    position: 'absolute',
    top: theme.spacing.unit * 10,
    right: theme.spacing.unit * 2,
    zIndex: 999,
      maxWidth: 300,
  },
  image: {
    width: "auto",
    height: 35
  },
    list:{
        padding: "0",
    },
  listItem:{
      padding: 0,
  }
});

const PopupMarker = ({ children, position }) => {
    const m = moment;
    return <Marker icon={L.icon({
        iconUrl: require('../../assets/images/marker-' + (!children.date && children.date_limit && (m(children.date_limit).isSameOrBefore(m().add(3, 'months')) ) ? children.status + "-late" : children.status ) + '.png'),
        iconSize: [96, 96],
        iconAnchor: [48, 80],
        popupAnchor: [-3, -76]
    })} position={position}>
        <Popup>
            <Typography variant="headline" gutterBottom>
                {(() => {
                    switch (children.status) {
                        case 'waiting':
                            return <Tooltip title="En attente"><HourglassEmptyIcon/></Tooltip>;
                        case 'appointment':
                            return <Tooltip title="Rendez-vous validé"><EventIcon/></Tooltip>;
                        case 'appointment_notified':
                            return <Tooltip title="Rendez-vous non validé"><CalendarTodayIcon/></Tooltip>;
                        case 'valid':
                            return <Tooltip title="Validé"><DoneIcon/></Tooltip>;
                        case 'issue':
                            return <Tooltip title="Écart"><BuildIcon/></Tooltip>;
                        case 'reject':
                            return <Tooltip title="Rejeté"><ClearIcon/></Tooltip>;
                        default:
                            return null;
                    }
                })()} {children.company.name}
            </Typography>
            <Typography variant="subheading" gutterBottom>
                {children.date ? moment(children.date).calendar() : "pas de rendez-vous"}
            </Typography>
            <Typography variant="body2" gutterBottom>
                {children.address}
            </Typography>
            <Button href={"/#/audits/" + children.id}>
                Voir détails
            </Button>
        </Popup>
    </Marker>
}

const MarkersList = ({ markers }) => {
  const items = markers.map(({ key, ...props }) => (
    <PopupMarker key={key} {...props} />
  ))
  return <div style={{ display: 'none' }}>{items}</div>
}

class Map extends React.Component {

  render() {
    const position = [this.props.lat, this.props.lng]
    return (
      <React.Fragment>
        <CssBaseline />
        <LMap center={position} zoom={this.props.zoom} maxZoom={20} className={this.props.classes.map + " markercluster-map"} zoomControl={false}>
          <LayersControl position="bottomleft">
            <BaseLayer checked name="Normal">
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution="&copy; <a href=&quot;https://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
              />
            </BaseLayer>
            <BaseLayer name="Noir & Blanc">
              <TileLayer
                attribution="&amp;copy <a href=&quot;https://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
                url="https://tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png"
              />
            </BaseLayer>
              {this.props.options.clustered ? (
                  <MarkerClusterGroup
                      averageCenter
                      enableRetinaIcons
                  >
                      <MarkersList markers={this.props.audits.map(audit => {
                          return { key: audit.id, position: [audit.latitude,audit.longitude], children: audit }
                      })} />
                  </MarkerClusterGroup>
              ) : (
                  <MarkersList markers={this.props.audits.map(audit => {
                      return { key: audit.id, position: [audit.latitude,audit.longitude], children: audit }
                  })} />
              )}
          </LayersControl>
          <ZoomControl position="bottomright" />
        </LMap>

        <ExpansionPanel className={this.props.classes.legend}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            Filtres
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <Grid container spacing={24}>
                <Grid item xs={12}>
                  <TextField
                      label="Rechercher l'entreprise..."
                      type="search"
                      variant="filled"
                      onChange={this.props.handleSearch}
                      style={{margin: 0}}
                      margin="normal"
                  />
                </Grid>
                <Grid item xs={4}>
                    <FormGroup row>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.props.options.clustered}
                                    onChange={this.props.handleChangeOptions('clustered')}
                                    value="Grouper"
                                />
                            }
                            label="Grouper"
                        />
                    </FormGroup>
                </Grid>
                <Grid item xs={8}>
                    <Button variant="contained" color="primary" onClick={this.props.openFilters}>
                        <DateRangeIcon />
                        Intervalle
                    </Button>
                </Grid>
              <Grid item xs={12}>
                <List className={this.props.classes.list}>
                  <ListItem className={this.props.classes.listItem}>
                      <Checkbox
                          checked={this.props.options.status.waiting}
                          onChange={this.props.handleChangeOptions('waiting')}
                          value="waiting"
                          color="primary"
                      />
                    <ListItemIcon>
                      <img src={markerWaiting} alt="en attente" className={this.props.classes.image}/>
                    </ListItemIcon>
                    <ListItemText primary="En attente"/>
                  </ListItem>
                  <ListItem className={this.props.classes.listItem}>
                      <Checkbox
                          checked={this.props.options.status.appointment}
                          onChange={this.props.handleChangeOptions('appointment')}
                          value="appointment"
                          color="primary"
                      />
                    <ListItemIcon>
                      <img src={markerAppointment} alt="rendez-vous validé" className={this.props.classes.image}/>
                    </ListItemIcon>
                    <ListItemText primary="Rendez-vous validé"/>
                  </ListItem>
                  <ListItem className={this.props.classes.listItem}>
                      <Checkbox
                          checked={this.props.options.status.appointment_notified}
                          onChange={this.props.handleChangeOptions('appointment_notified')}
                          value="appointment_notified"
                          color="primary"
                      />
                      <ListItemIcon>
                          <img src={markerAppointmentNotified} alt="rendez-vous non validé" className={this.props.classes.image}/>
                      </ListItemIcon>
                      <ListItemText primary="Rendez-vous non validé"/>
                  </ListItem>
                  <ListItem className={this.props.classes.listItem}>
                      <Checkbox
                          checked={this.props.options.status.issue}
                          onChange={this.props.handleChangeOptions('issue')}
                          value="issue"
                          color="primary"
                      />
                    <ListItemIcon>
                      <img src={markerIssue} alt="écart" className={this.props.classes.image}/>
                    </ListItemIcon>
                    <ListItemText primary="Écart"/>
                  </ListItem>
                </List>
              </Grid>

            </Grid>
          </ExpansionPanelDetails>
        </ExpansionPanel>


        <DateRangeDialog dateStart={this.props.dateStart} dateEnd={this.props.dateEnd} title="Intervalle" open={this.props.dialogIsOpen} onCancel={this.props.onCancelDialog} onChangeDateRange={this.props.onChangeDateRange} />

      </React.Fragment>
    );
  }
}

Map.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Map);



// WEBPACK FOOTER //
// ./src/component/map/map.js